export const editProfileStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    width: {
      xs: "90vw",
      sm: "70vw",
      md: "40vw",
    },
    marginRight: "auto",
    marginLeft: "auto",
  },

  avatarContainer: {
    textAlign: "center",
    marginTop: "1rem",
    position: "relative",
  },

  avatar: {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    objectFit: "cover",
    margin: "0 auto",
  },

  updateAvatarText: {
    textDecoration: "underline",
    fontSize: "17px",
    fontWeight: "600",
    marginTop: "5px",
    cursor: "pointer",
  },

  backButton: {
    position: "absolute",
    top: "1rem",
    left: "1rem",
  },

  saveButton: {
    width: "100%",
    marginTop: "20px",
    paddingY: "10px",
  },
};
